<ng-container *ngIf="!isExternal(); else external">
    <div class="layout-container"
         [class.blocking-page]="isTermsPage() || isPortalNotificationPage() || isForceResetRequired()"
         [class.change-password-page]="isChangePasswordPage()">

        <mat-toolbar
                style="background-color:{{getBackgroundColor()}};--mat-toolbar-container-text-color:{{getHeaderTextColor()}}"
                class="mxs-header">
            <mat-toolbar-row class="head_wrapper" [ngClass]="{'unauthorized': !authService.loggedInUser()}">
                <button *ngIf="authService.loggedInUser() && !isTermsPage() && !isPortalNotificationPage() && !isForceResetRequired()"
                        class="mxs-menu-button"
                        type="button"
                        aria-label="Toggle sidenav"
                        matTooltip="Toggle navigation menu"
                        mat-icon-button (click)="snav.toggle()">
                    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
                </button>
                <div class="logo" (click)="navigateToHome()">
                    <img [src]="getLogo()">
                </div>

                @if (!isForceResetRequired()) {
                    <prl-active-account></prl-active-account>
                }
                @if (!authService.loggedInUser() && !isLoginPage() && !isChangePasswordPage()) {
                    <div>
                        <a class="mxs-header_login" [routerLink]="['/login']">
                            <prl-label value="label.login"/>
                        </a>
                    </div>
                }
                @if (!isForceResetRequired()) {
                    <prl-language-picker [hoverColor]="getHoverColor()"></prl-language-picker>
                }
            </mat-toolbar-row>
        </mat-toolbar>

        <mat-sidenav-container class="mxs-menu-wrapper" autosize>
            <mat-sidenav #snav [mode]="sidenavMode"
                         [opened]="authService.loggedInUser() && !isTermsPage() && !isPortalNotificationPage() && !isForceResetRequired() && this.sidenavOpened"
                         role="navigation" class="mxs-sidenav">

                @if (authService.loggedInUser() && !isTermsPage() && !isPortalNotificationPage() && !isForceResetRequired()) {
                    <mx-navigation-menu (menuItemSelected)="onMenuItemSelected()"></mx-navigation-menu>
                }
            </mat-sidenav>

            <mat-sidenav-content>
                <mx-preloader></mx-preloader>
                <div class="main-content-wrapper" [ngClass]="{'unauthorized': !authService.loggedInUser()}">
                    <router-outlet></router-outlet>
                </div>
                <div class="copyright">
                    <div> Copyright © 2010-2026 by Playtech Group. All rights reserved |</div>
                    <a [routerLink]="['/terms']">
                        <prl-label style="color:{{getLabelColor()}}" value="label.terms.and.conditions"/>
                    </a>
                    <div>| Powered by <a style="color:{{getLabelColor()}}"
                                         href="https://www.playtech.com/">www.playtech.com</a></div>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>
</ng-container>
<ng-template #external>
    <router-outlet></router-outlet>
</ng-template>